import { toast } from "sonner";
import api from "@/lib/api";
import { inputCls } from "@/components/admin/finance/common";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const PRESETS = {
  month: () => { const n = new Date(); return { from: iso(new Date(n.getFullYear(), n.getMonth(), 1)), to: iso(new Date(n.getFullYear(), n.getMonth() + 1, 0)) }; },
  quarter: () => { const n = new Date(); const q = Math.floor(n.getMonth() / 3) * 3; return { from: iso(new Date(n.getFullYear(), q, 1)), to: iso(new Date(n.getFullYear(), q + 3, 0)) }; },
  year: () => { const y = new Date().getFullYear(); return { from: `${y}-01-01`, to: `${y}-12-31` }; },
  all: () => ({ from: "", to: "" }),
};
const LABELS = { month: "Ce mois", quarter: "Ce trimestre", year: "Cette année", all: "Tout" };

export const periodQuery = (p) => `${p.from ? `&date_from=${p.from}` : ""}${p.to ? `&date_to=${p.to}` : ""}`;

export async function downloadCsv(path, name) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a"); a.href = url; a.download = name; a.click();
    URL.revokeObjectURL(url);
  } catch { toast.error("Export impossible (droits insuffisants ?)"); }
}

export function PeriodFilter({ value, onChange, testid = "period" }) {
  const active = Object.keys(PRESETS).find((k) => { const p = PRESETS[k](); return p.from === value.from && p.to === value.to; });
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testid}-filter`}>
      {Object.keys(PRESETS).map((k) => (
        <button key={k} onClick={() => onChange(PRESETS[k]())} data-testid={`${testid}-preset-${k}`}
          className={`px-3 py-2 rounded-lg text-xs font-medium transition-colors ${active === k ? "bg-[#3B82F6] text-white" : "bg-[#1E293B] text-slate-300 hover:bg-[#283548]"}`}>{LABELS[k]}</button>
      ))}
      <span className="text-xs text-slate-500 ml-1">Du</span>
      <input type="date" value={value.from} onChange={(e) => onChange({ ...value, from: e.target.value })} data-testid={`${testid}-from`} className={`${inputCls} !w-auto [color-scheme:dark]`} />
      <span className="text-xs text-slate-500">au</span>
      <input type="date" value={value.to} onChange={(e) => onChange({ ...value, to: e.target.value })} data-testid={`${testid}-to`} className={`${inputCls} !w-auto [color-scheme:dark]`} />
    </div>
  );
}
